import React from "react";
import { useDispatch } from "react-redux";
import {openPharmacyOrderRejectModal, openPharmacyOrderAcceptModal, openPharmacyOrderPartialModal} from "../../../../../redux/actions/modals";
import SafeCallComponent from "../../lab-orders/LabOrderItem/children/SafeCallComponent";
const PharmacyVendorAssignedActions = (props) => {
    console.log("props in actions", props)
    const dispatch = useDispatch();
    const renderPartialOrderBtns = () => {
        if(props.prescriptions.length !== 0 && props.prescriptions !== undefined && props.prescriptions !== null) {
            if(props.prescriptions.length > 1 || props.prescriptions[0].tag !== "OTC") {
                return (
                    <div className="partial-order-btn-holder ">
                        <button
                            className="btn btn-small btn-success btn-accept margin-bottom-5"
                            onClick={() => {
                                dispatch(openPharmacyOrderPartialModal(props, 'simple'));
                            }}
                        >
                            <div className="title">
                            قبول سفارش به صورت موردی
                            </div>
                            <div className="sub-title">
                            در صورت ناموجود بودن یک یا چند مورد از اقلام سفارش
                            </div>
                        </button>
                    </div>
                )
            }
        }
    }
    return (
        <>
            <div className="flex-column pharmacy-actions-buttons">
                <button
                    className="btn btn-small btn-success btn-accept margin-bottom-5"
                    onClick={() => {
                        dispatch(openPharmacyOrderAcceptModal(props, 'simple'));
                    }}
                >
                    <div className="title">
                        قبول سفارش به صورت عادی
                    </div>
                    <div className="sub-title">
                        (پیک یک طرفه بدون نیاز به نسخه)
                    </div>
                </button>
                <button
                    className="btn btn-small btn-success btn-accept margin-bottom-5"
                    onClick={() => {
                        dispatch(openPharmacyOrderAcceptModal(props,'insurance'));
                    }}
                >
                    <div className="title">
                        قبول سفارش تحت پوشش بیمه
                    </div>
                    <div className="sub-title">
                        (پیک رفت و برگشت اختیاری جهت دریافت اصل نسخه)
                    </div>
                </button>
                <button
                    className="btn btn-small btn-success btn-accept margin-bottom-5"
                    onClick={() => {
                        dispatch(openPharmacyOrderAcceptModal(props,'special'));
                    }}
                >
                    <div className="title">
                        قبول سفارش داروی خاص
                    </div>
                    <div className="sub-title">
                        (پیک رفت و برگشت الزامی جهت دریافت اصل نسخه)
                    </div>
                </button>
          {/*      {renderPartialOrderBtns()}*/}
              {/*  <SafeCallComponent order={props} />*/}
                <button
                    className="btn btn-small btn-outline-dark btn-accept margin-bottom-5"
                    onClick={() => {
                        dispatch(openPharmacyOrderRejectModal(props));
                    }}
                >
                    رد سفارش
                </button>
                
            </div>
        </>
    );
};
export default PharmacyVendorAssignedActions;